import { constructEnum } from '@/lib/enum';

export default constructEnum('ReviewPointType', {
  NONE: -1,
  MILEAGE: 0,
  COUPON: 10,
  POINT: 20,
  DISCOUNT_CODE: 30
});
